import React from "react"
import CurrentPlanCard from "./cards/CurrentPlanCard"
import BillingHistory from "./BillingHistory"
import CancelSubscription from "./CancelSubscription"
import PaymentDetails from "./PaymentDetails"


const MainContent = ({ openModal }) => {

  return (<>
    <div className="flex-fill overflow-auto mt-2">
      <div className="">
        {/* Current Plan & Next Billing */}
        <div className="row g-4 mb-4 mx-0">
          <div className="col-lg-6 p-0 pe-md-3 p-sm-0">
            <CurrentPlanCard openModal={openModal} />
          </div>
          <div className="col-lg-6 p-0 px-md-2 p-sm-0">
            <PaymentDetails openModal={openModal}/>
          </div>
        </div>

        {/* Billing History */}
        <BillingHistory />

        {/* Cancel Subscription */}
        <CancelSubscription openModal={openModal} />
      </div>
    </div>
  </>
  )
}

export default MainContent
